import React, {Component} from 'react';
import {Card, Label, Grid} from 'semantic-ui-react';
import ReactMarkdown from "react-markdown";
import {FormattedRelative} from "react-intl";

class ChangelogCard extends Component {
    render() {
        return (
            <Grid.Row columns={2} centered>
                <Grid.Column mobile={16} tablet={12} computer={10} largeScreen={10} widescreen={10}>
                    <Card fluid>
                        <Card.Content>
                            <Card.Header>{this.props.title}</Card.Header>
                            <Card.Meta>
                                <Label style={{backgroundColor: this.props.category.color, color:'#fff'}}>{this.props.category.name}</Label> <FormattedRelative value={this.props.date}/>
                            </Card.Meta>
                        </Card.Content>
                        <ReactMarkdown source={this.props.content} className='markdown'/>
                    </Card>
                </Grid.Column>
            </Grid.Row>
        );
    }
}
export default ChangelogCard;



// WEBPACK FOOTER //
// ./src/components/updates/ChangelogCard.js